import React from "react";
import DOMPurify from "dompurify";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

export interface FaqItem { id: string; question: string; answer_html: string; audiences: string[]; order: number }
export const FAQ_LABELS: Record<string, string> = { cellar: "Cellar Plan", club: "Wine Club", gift: "Gift a subscription" };

export function FaqAccordion({ items, testId = "faq-accordion" }: { items: FaqItem[]; testId?: string }) {
  if (!items.length) return <p className="text-sm text-neutral-500" data-testid={`${testId}-empty`}>No questions here yet.</p>;
  return (
    <Accordion type="single" collapsible className="border-t border-border" data-testid={testId}>
      {items.map((it) => (
        <AccordionItem key={it.id} value={it.id} className="border-border" data-testid={`faq-item-${it.id}`}>
          <AccordionTrigger className="py-5 font-brand text-[13px] font-bold uppercase tracking-[0.06em] text-[#202020] hover:no-underline hover:text-[var(--wine)] data-[state=open]:text-[var(--wine)] [&>svg]:text-[var(--wine)]" data-testid={`faq-question-${it.id}`}>{it.question}</AccordionTrigger>
          <AccordionContent className="max-w-2xl pb-6 text-[15px] leading-relaxed text-neutral-800 [&_p]:mt-2 [&_p:first-child]:mt-0 [&_a]:underline [&_ul]:list-disc [&_ul]:pl-5" data-testid={`faq-answer-${it.id}`}>
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(it.answer_html, { USE_PROFILES: { html: true } }) }} />
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
